export default {
    price: 8000,
    hasCustomBackground: true,
    light: {
        primary: '#267373',
        secondary: '#424242',
        accent: '#66CC66',
    },
    dark: {
        primary: '#66CCCC',
        secondary: '#424242',
        accent: '#267326',
    }
}
